import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Portfolio from "@/pages/Portfolio";
import About from "@/pages/About";
import Vendors from "@/pages/Vendors";
import Contact from "@/pages/Contact";
import { AuthProvider } from "@/admin/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import AdminLogin from "@/admin/AdminLogin";
import AdminApp from "@/admin/AdminApp";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function PublicLayout() {
  return (
    <ContentProvider>
      <Navbar />
      <main><Outlet /></main>
      <Footer />
    </ContentProvider>
  );
}

function AdminLayout() {
  return <main><Outlet /></main>;
}

function App() {
  return (
    <div className="App bg-cream min-h-screen text-ink">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/about" element={<About />} />
              <Route path="/vendors" element={<Vendors />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route element={<AdminLayout />}>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/*" element={<AdminApp />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
